import { batchActions } from "redux-batched-actions";
import { displayErrorMessage, displaySuccessMessage } from '@insticator/insticator-ui'; // iui-utils
// api
import { asyncGetRatingsConfig, asyncUpdateColorConfiguration, asyncSaveRatingsGeneral } from 'utils/api/ratings';

// constants
export const RECEIVE_RATINGS_CONFIG = 'RECEIVE_RATINGS_CONFIG';
export const FETCHING_RATINGS_CONFIG = 'FETCHING_RATINGS_CONFIG';
export const SAVE_RATINGS_COLOR_CONFIG = 'SAVE_RATINGS_COLOR_CONFIG';
export const SAVING_RATINGS_COLOR_CONFIG = 'SAVING_RATINGS_COLOR_CONFIG';

export const SAVE_RATING_GENERAL_SUCCESS = 'SAVE_RATING_GENERAL_SUCCESS';
export const SAVING_RATING_GENERAL = 'SAVING_RATING_GENERAL';

// actions
const receiveRatingsData = data => ({
    type: RECEIVE_RATINGS_CONFIG,
    data
});

const fetchingRatingsData = status => ({
    type: FETCHING_RATINGS_CONFIG,
    status
});

const saveRatingsColorConfig = data => ({
    type: SAVE_RATINGS_COLOR_CONFIG,
    data
});

const savingRatingsColorConfig = status => ({
    type: SAVING_RATINGS_COLOR_CONFIG,
    status
});

const saveGeneralData = data => ({
    type: SAVE_RATING_GENERAL_SUCCESS,
    data
});

const savingGeneralData = status => ({
    type: SAVING_RATING_GENERAL,
    status
});

// batched actions

const ratingsDataSuccess = (data) => batchActions([receiveRatingsData(data), fetchingRatingsData(false)]);
const ratingsDataFail = () => batchActions([displayErrorMessage('There was a problem fetching Ratings Data.'), fetchingRatingsData(false)]);

const saveRatingsColorConfigSuccess = (data) => batchActions([saveRatingsColorConfig(data), displaySuccessMessage('Color Scheme Updated'), savingRatingsColorConfig(false)]);
const saveRatingsColorConfigFail = () => batchActions([displayErrorMessage('There was an issue updating the color scheme.'), savingRatingsColorConfig(false)]);

const saveRatingGeneralSuccess = (data) => batchActions([saveGeneralData(data), displaySuccessMessage('General Settings Updated'), savingGeneralData(false)]);
const saveRatingGeneralFail = () => batchActions([displayErrorMessage('There was a problem fetching Ratings Data.'), savingGeneralData(false)]);

// thunks

export const getRatingsConfig = (accountUUID, siteUUID, siteUrl, callback) => dispatch => {
    dispatch(fetchingRatingsData(true))
    asyncGetRatingsConfig(accountUUID, siteUUID, siteUrl)
        .then(response => {
            if(callback) callback()
            dispatch(ratingsDataSuccess(response.data)) })
        .catch(err => dispatch(ratingsDataFail()))
};

export const saveRatingsColorConfiguration = (colorConfigUUID, customColorSchema, collapse) => dispatch => {
    dispatch(savingRatingsColorConfig(true))
    asyncUpdateColorConfiguration(colorConfigUUID, customColorSchema)
        .then(response => {
            collapse && collapse();
            dispatch(saveRatingsColorConfigSuccess(response.data))
        })
        .catch(err => dispatch(saveRatingsColorConfigFail()))
};

export const saveRatingsGeneral = (configID, data, collapse) => dispatch => {
    dispatch(savingGeneralData(true))
    asyncSaveRatingsGeneral(configID, data)
        .then(response => {
            collapse && collapse();
            dispatch(saveRatingGeneralSuccess(response.data))
        })
        .catch(err => dispatch(saveRatingGeneralFail()))
}

